import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { APIResponseWrapper } from '../../models/common/api-response-wrapper';
import { Driver } from '../driver/driver.model';
import { Vehicle } from '../vehicle/vehicle.model';

export interface QuickFleetPairOnboardingRequest {
    owningCompanyId: number;
    source: 'owned' | 'freelance' | 'rental' | 'transporter';
    transporterCrmClientId?: number | null;
    rentalAgreementId?: number | null;
    driver: Driver;
    vehicle: Vehicle;
}

export interface QuickFleetPairOnboardingResponse {
    driver: Driver;
    vehicle: Vehicle;
}

@Injectable({ providedIn: 'root' })
export class QuickFleetOnboardingService {
    private readonly baseUrl = `${environment.restApiUrl}fleet/quick-onboarding`;

    constructor(private http: HttpClient) {}

    onboardPair(request: QuickFleetPairOnboardingRequest): Observable<APIResponseWrapper<QuickFleetPairOnboardingResponse>> {
        return this.http.post<APIResponseWrapper<QuickFleetPairOnboardingResponse>>(`${this.baseUrl}/pairs`, request);
    }
}
